/**
 * @fileoverview GET handler for the "/app_settings/custom_events_tags" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appSettingsCustomEventsTags } from "./constants";
import type { AppSettingsCustomEventsTagsResult } from "./types";

export const getAppSettingsCustomEventsTags = reactQueryFetcherAdapter(
  appSettingsCustomEventsTags,
  (signal: AbortSignal): Promise<AppSettingsCustomEventsTagsResult> => {
    return fetch("/app_settings/custom_events_tags", "GET", {}, { signal });
  }
);
